"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaKekkaJissiPlace = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 内部監査実施場所
 */
const KansaKekkaJissiPlace = props => {
  const {
    intl,
    naibukansaJissiPlace,
    onChange,
    error,
    helperText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_KANSA_JISSI_PLACE
    })
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: naibukansaJissiPlace,
    onChange: onChange,
    maxLength: 200,
    error: !!error,
    helperText: helperText
  }));
};
exports.KansaKekkaJissiPlace = KansaKekkaJissiPlace;
var _default = exports.default = (0, _reactIntl.injectIntl)(KansaKekkaJissiPlace);